<template>
  <div class="header__dropdown-container">
    <div class="header__dropdown-container-inner">
      <div
        class="header__dropdown-container-inner-links-small-images-container"
        :class="[{'header__dropdown-container-inner-links--single-column' : block.image_1 && block.image_2 }]"
      >
        <div class="header__dropdown-container-inner-featured-menu-links-container">
          <div
            class="header__dropdown-lists-container header__dropdown-list-menu-links-main-container"
          >
            <ul
              class="header__dropdown-list header__dropdown-list-menu-links-container"
              v-for="(link, index) in block.link_list"
              :key="index"
            >
              <li class="header__dropdown-list-links-image-container">
                <div class="header-dropdown-list-links-container">
                  <p
                    v-if="index > 0"
                    class="header__dropdown-list-title uppercase h8"
                    :class="{'header__dropdown-list-title--margin-bottom-none': !(link.children && link.children.length > 0)}"
                  >{{ link.title }}</p>
                  <ul v-for="(child_link, index) in link.children" :key="index">
                    <li class="header__dropdown-list-item">
                      <v-link
                        secondary
                        class="header__dropdown-link"
                        :href="child_link.url"
                      >{{ child_link.title }}
                      <span v-if="child_link.title =='Shop All'">
                        <icon class="arrow-icon" name="arrow_long_right" />
                      </span>
                      </v-link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="header__dropdown-small-images-container">
          <div
            :class="{ 'header__dropdown-image-outer-container': true,  'header__dropdown-image-outer-container--full': !block.image_2 && block.image_1 }"
            v-if="block.image_1"
          >
            <a
              class="header__dropdown-image-outer-content-container"
              v-if="block.image_1_url"
              :href="block.image_1_url"
            >
              <div class="header__dropdown-image-container">
                <img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text" />
              </div>
              <div class="header-menu-image-title link link--secondary" v-if="block.image_1_text">
                {{ block.image_1_text }}
              </div>
            </a>
            <div class="header__dropdown-image-outer-content-container" v-else>
              <div class="header__dropdown-image-container">
                <img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text" />
              </div>
              <p class="header-menu-image-title" v-if="block.image_1_text">{{ block.image_1_text }}</p>
            </div>
          </div>
          <div
            :class="{ 'header__dropdown-image-outer-container': true,  'header__dropdown-image-outer-container--full': block.image_2 && !block.image_1 }"
            v-if="block.image_2"
          >
            <a
              class="header__dropdown-image-outer-content-container"
              v-if="block.image_2_url"
              :href="block.image_2_url"
            >
              <div class="header__dropdown-image-container">
                <img class="header__dropdown-image" :src="block.image_2" :alt="block.image_2_text" />
              </div>
              <div class="header-menu-image-title link link--secondary" v-if="block.image_2_text">
                {{ block.image_2_text }}
              </div>
            </a>
            <div class="header__dropdown-image-outer-content-container" v-else>
              <div class="header__dropdown-image-container">
                <img class="header__dropdown-image" :src="block.image_2" :alt="block.image_2_text" />
              </div>
              <p class="header-menu-image-title" v-if="block.image_2_text">{{ block.image_2_text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
import VLink from '@/scripts/components/buttons/VLink.vue';

export default {
  name: 'NavbarDesktopSmallImageBlocks',
  components: { Icon, VLink },
  props: {
    block: Object,
  },
};
</script>

<style scoped lang="scss">
.header__dropdown-lists-container {

  @include tablet-up {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @include desktop-up {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-row-gap: 20px;
    /* height: 306px; */
    width: 100%;
    margin-right: 32px;
    overflow: hidden;
    align-content: flex-start;
    margin-bottom: -32px;

    ul:first-of-type {
      grid-row: 1 / span 2;
    }
  }
}

.header__dropdown-list-menu-links-container {
  @include desktop-up {
    margin-bottom: 32px;
    margin-right: 0;
  }
}

.nav-links-dropdown-content-container {
  @include desktop-up {
    display: block;
  }
}

.header__dropdown-container-inner {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include desktop-up {
    flex-direction: row;
    justify-content: space-between;
    max-width: $container-max-width;
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px;
  }
}

.header__dropdown-side-list {
  border-right: 1px solid $color-grey;
  padding-left: 0;
  padding-right: 16px;
  list-style: none;
  margin-right: 31px;
  margin-bottom: 0;
  width: 192px;
}

.header__dropdown-side-list .header__dropdown-list {
  margin-bottom: 0;
}

.header__dropdown-featured-link {
  display: flex;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 22px;
}

.header__dropdown-list {
  @include desktop-up {
    margin-bottom: 12px;
    width: 195px;
    margin-right: 32px;
  }

  @media (min-width: 1200px) {
    margin-right: 28px;
  }

  &:first-child {
    .link--secondary {
      font-family: $font-family-primary;
      font-size: rem(24);
      line-height: rem(31);
    }
  }
  &:last-child {
    margin-right: 0;
  }
}

.header__dropdown-list,
.header__dropdown-list ul {
  padding-left: 0;
  list-style: none;
}

.header__dropdown-list-title {
  margin-bottom: 12px;
  color: $color-terracotta-500;
  font-size: rem(12);
  letter-spacing: rem(2.86);
  line-height: (20 / 12);
}

.header__dropdown-list-item {
  line-height: 1;
}

.header__dropdown-list-title--margin-bottom-none {
  margin-bottom: 0;
}

.header__dropdown-link {
  margin-bottom: 8px;

  &.link {
    font-family: $font-family-secondary;
  }
}

.header__dropdown-lists-images-inner-container {
  display: flex;
  padding-left: 16px;

  @include mobile-tablet {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-y: hidden;
    position: relative;
    margin: 0;
  }
}

.header__dropdown-image-link-container {
  display: inline-block;
  list-style: none;
  width: 290px;
  vertical-align: top;
  margin-right: 32px;
}

.header-menu-image-title {
  padding-right: 5px;
  margin: 0;
  margin-top: 16px;
  display: flex;
  align-items: center;
  color: $color-brand-primary;
  display: inline-block;
  font-weight: 400;
  font-family: $font-family-primary;
  font-size: rem(20);

  &:hover {
    &::before {
      background-color: $color-brand-primary;
    }
  }

  &:before {
    background-color: $color-brand-primary;
  }
}

.header__dropdown-image-link-container:last-child {
  margin-right: 0;
}

.header__dropdown-container-inner-featured-menu-links-container {
  @include desktop-up {
    display: flex;
  }
}

.header__dropdown-container-inner-text-blocks-links-container {
  width: 100%;
  display: flex;
}

.header__dropdown-lists-outer-container {
  display: flex;
}

.header__dropdown-lists-images-container {
  @include desktop-up {
    display: flex;
    justify-content: flex-end;
  }
}

.header__dropdown-image-link-inner-container {
  display: flex;
  flex-direction: column;

  @include desktop-up {
    width: auto;
    display: inline-block;
  }
}

a .header__dropdown-image-link-inner-container {
  cursor: pointer;
}

.header__dropdown-container-inner-links-small-images-container {
  display: flex;
  flex-direction: column;

  @include desktop-up {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
}

.header__dropdown-container-inner-links--single-column
  .header__dropdown-container-inner-featured-menu-links-container,
.header__dropdown-container-inner-links--single-column .header__dropdown-list {
  overflow: hidden;
}

.header__dropdown-container-inner-links--single-column
  .header__dropdown-side-list {
  border-right: 0;
}

.header__dropdown-container-inner-links-small-images-container
  .header__dropdown-container-inner-featured-menu-links-container {
  @include desktop-up {
    display: flex;
    width: 100%;
    max-width: 715px;
    flex: 0 0 auto;
  }

  @media screen and (min-width: 1200px) {
    max-width: 900px;
  }
}

.header__dropdown-container-inner-links-small-images-container
  .header__dropdown-small-images-container {
  width: 100%;
  flex: 1;
  @media screen and (min-width: 1200px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

.header__dropdown-inner-small-images-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header__dropdown-small-images-container {
  display: flex;
  flex-direction: column;
  @include desktop-up {
    flex-direction: row;
    justify-content: center;
  }
}

.header__dropdown-small-images-container .header__dropdown-image-container {
  // @include desktop-up {
  //   width: 220px;
  // }
  // @media screen and (min-width: 1100px) {
  //   width: 260px;
  // }
  // @include hd-up {
  //   width: 290px;
  // }
  /* height: 0; */
  overflow: hidden;
  padding-top: 100%;
  position: relative;
}

.header__dropdown-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header__dropdown-images-large-image img {
  display: block;
  width: 100%;
}

.header__dropdown-image-outer-container {
  margin-right: 24px;
  flex: 1;
  max-width: 232px;
  &:last-child {
    margin-right: 0;
  }
  &--full {
    max-width: 464px;
    margin-right: 0;
    .header__dropdown-image-container {
      max-width: 250px;
      margin: 0 auto;
      /* padding-top: 50%; */
    }
  }
}

.header__dropdown-image-outer-container:last-child {
  margin-right: 0;
  padding-left: 50px;
  text-align: center;
}

.menu-image-link-arrow svg,
.header-menu-image-title svg {
  fill: $color-brand-primary;
}

.menu-image-link-arrow svg {
  margin-top: -1px;
}
.h8 {
  font-size: 0.7rem;
  font-weight: 400;
}
</style>
